<template>
  <!-- $t is vue-i18n global function to translate lang -->
  <div class="travelers-use-container">
    <!-- 登入/登出紀錄 -->
    <el-dialog
      v-if="currentTravelRecordRow && currentTravelRecordRow.loginTimes"
      append-to-body
      :top="dialogTopMargin"
      :title="`${currentTravelRecordRow.userName}登入/登出紀錄`"
      :visible.sync="dialogTravelersLoginRecordVisible"
      width="40%"
    >
      <el-card class="box-card" style="overflow-y: auto">
        <div style="max-height: 450px">
          <div style="position: relative; height: 100%">
            <el-table
              v-loading="listLoading"
              size="mini"
              :data="currentTravelRecordRow.loginTimes"
              border
              fit
              highlight-current-row
              height="100%"
            >
              <el-table-column align="center" label="項次" width="60">
                <template slot-scope="scope">
                  <span>{{ scope.$index + 1 }}</span>
                </template>
              </el-table-column>

              <el-table-column align="center" label="登入日期">
                <template slot-scope="scope">
                  <el-tag type="info" effect="plain" v-if="scope.row.type == 1">
                    {{ `${scope.row.dateTime}` }}
                  </el-tag>
                </template>
              </el-table-column>

              <el-table-column align="center" label="登出日期">
                <template slot-scope="scope">
                  <el-tag type="danger" effect="plain" v-if="scope.row.type == 2">
                    {{ `${scope.row.dateTime}` }}
                  </el-tag>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </el-card>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogTravelersLoginRecordVisible = false" type="danger"
          >關 閉</el-button
        >
      </span>
    </el-dialog>
    <!-- 匯入/異動/取消紀錄 -->
    <el-dialog
      v-if="currentTravelRecordRow && currentTravelRecordRow.details"
      append-to-body
      :top="dialogTopMargin"
      :title="`【${currentTravelRecordRow.userName}】匯入/異動/取消紀錄`"
      :visible.sync="dialogTravelersModifyRecordVisible"
      width="50%"
    >
      <el-card class="box-card">
        <div style="max-height;:450px">
          <div style="position: relative; height: 100%">
            <el-table
              v-loading="listLoading"
              size="mini"
              :data="currentTravelRecordRow.details"
              border
              fit
              highlight-current-row
              height="100%"
            >
              <el-table-column align="center" label="項次" width="60">
                <template slot-scope="scope">
                  <span>{{ scope.$index + 1 }}</span>
                </template>
              </el-table-column>

              <el-table-column align="center" label="異動項目" width="150">
                <template slot-scope="scope">
                  <el-tag :type="getTravelersModifyStatusStyle(scope.row.status)">
                    {{ `${scope.row.description}` }}
                  </el-tag>
                </template>
              </el-table-column>

              <el-table-column align="center" label="操作者" width="200">
                <template slot-scope="scope">
                  {{ scope.row.buildUserName }}
                  <!-- <el-tag type="success" effect="plain">
                    {{ `${scope.row.buildUserName}` }}
                  </el-tag> -->
                </template>
              </el-table-column>

              <el-table-column align="center" label="操作時間">
                <template slot-scope="scope">
                  {{ scope.row.date }}
                  <!-- <el-tag type="info">
                    {{ `${scope.row.date}` }}
                  </el-tag> -->
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </el-card>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogTravelersModifyRecordVisible = false" type="danger"
          >關 閉</el-button
        >
      </span>
    </el-dialog>

    <div>
      <!-- <el-tag>{{ travelName }}</el-tag> -->
      <el-card class="box-card">
        <div>
          <div style="position: relative; height: 80%">
            <el-table
              v-loading="listLoading"
              size="mini"
              :data="travelersRecordList"
              border
              fit
              highlight-current-row
              height="400px"
            >
              <el-table-column align="center" label="項次" width="60">
                <template slot-scope="scope">
                  <span>{{ scope.$index + 1 }}</span>
                </template>
              </el-table-column>

              <el-table-column align="center" label="參團" width="80">
                <template slot-scope="scope">
                  <el-tag :type="scope.row.include ? 'success' : 'danger'">
                    {{ `${scope.row.include ? '是' : '否'}` }}
                  </el-tag>
                </template>
              </el-table-column>

              <el-table-column align="center" label="姓名">
                <template slot-scope="scope">
                  {{ scope.row.userName }}
                </template>
              </el-table-column>

              <el-table-column align="center" label="登入次數" width="150">
                <template
                  slot-scope="scope"
                  v-if="scope.row.loginTimes && scope.row.loginTimes.length > 0"
                >
                  <el-tag type="success" size="mini">{{
                    partingLoginTime(scope.row.loginTimes, 1).length
                  }}</el-tag
                  >/<el-tag type="danger" size="mini">{{
                    partingLoginTime(scope.row.loginTimes, 2).length
                  }}</el-tag>
                </template>
              </el-table-column>

              <el-table-column align="center" label="登入明細" width="150">
                <template slot-scope="scope">
                  <el-button size="mini" type="success" @click="getLoginDetails(scope.row)"
                    >登入明細</el-button
                  >
                </template>
              </el-table-column>

              <el-table-column align="center" label="匯入紀錄">
                <template slot-scope="scope">
                  <el-button size="mini" type="warning" @click="getModifyDetails(scope.row)"
                    >匯入紀錄</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
import { getTravelersDetails } from '@/api/agency'

export default {
  name: 'TravelersUsed',
  components: {},
  props: {
    travelID: {
      type: Number,
      default: null,
    },
    travelName: {
      type: String,
      default: null,
    },
  },
  watch: {
    async travelID(val) {
      if (val) {
        await this.getTravelersDetails()
      }
    },
  },
  async activated() {},
  data() {
    return {
      dialogTopMargin: '5%',
      formLabelWidth: '120px',
      listLoading: false,
      currentTravelRow: null,
      currentTravelRecordRow: null,
      dialogTravelersLoginRecordVisible: false,
      dialogTravelersModifyRecordVisible: false,
      dialogTravelersDetailsVisible: false,
      travelersRecordList: [],
    }
  },
  async created() {
    if (this.travelID) {
      await this.getTravelersDetails()
    }
  },
  methods: {
    partingLoginTime(data, type) {
      return data.filter(f => f.type == type)
    },
    getTravelersModifyStatusStyle(status) {
      let r = ''
      switch (status) {
        case 1:
        case 2:
          r = 'success'
          break
        case 3:
        case 4:
          r = ''
          break
        case 5:
          r = 'danger'
          break
        default:
          break
      }
      return r
    },
    async getLoginDetails(row) {
      let vm = this
      vm.currentTravelRecordRow = row
      vm.dialogTravelersLoginRecordVisible = true
    },
    async getModifyDetails(row) {
      let vm = this
      vm.currentTravelRecordRow = row
      vm.dialogTravelersModifyRecordVisible = true
    },
    async getTravelersDetails() {
      let vm = this
      // vm.currentTravelRow = row;
      vm.listLoading = true
      try {
        let resp = await getTravelersDetails({ travelID: this.travelID })
        vm.travelersRecordList = resp.data
        vm.dialogTravelersDetailsVisible = true
      } catch (error) {
        console.log(error)
      } finally {
        vm.listLoading = false
      }
    },
  },
}
</script>

<style scoped>
.el-dialog__body {
  padding: 15px !important;
}
</style>
